// Approving a joining review creates a login and emails the credentials, and cannot be taken back,
// so it asks first. Sending the document back is safe and goes straight through (triage FE-05-12).
export function approvalConfirmed(decision, candidateName, ask) {
  if (decision !== "approve") return true;
  return ask(`Create a login for ${candidateName || "this candidate"} and email their credentials?`);
}
